import restful from '@/utils/restful';
import * as names from '@/store/names';
import * as get from '@/store/store';

// Descriptores del Diseño Instruccional: bloques de texto libre con su título, debajo
// del resumen. Es el mismo patrón que los del Programa (EPMMiddleDescriptor) y comparte
// SU catálogo de títulos (EgressProfileMatterDescriptor); lo que los separa es el
// `page_position` del título, que para el Diseño es 3.
const state = {
    instructional_design_descriptors: [],
    instructional_design_descriptors_url: '/teaching/instructional-design-descriptor'
}

const getters = {
    [names.INSTRUCTIONAL_DESIGN_DESCRIPTORS]: state => {
        if (!get.store.state.user) return [];
        return state.instructional_design_descriptors
            .filter((x) => x.school == get.store.state.user.school)
            .sort(function (a, b) {
                if (a.order > b.order) return 1;
                if (a.order < b.order) return -1;
                return 0;
            });
    },
}

const mutations = {
    [names.MUTATE_INSTRUCTIONAL_DESIGN_DESCRIPTORS]: (state, instructional_design_descriptors) => {
        instructional_design_descriptors.forEach(element => {
            let index = state.instructional_design_descriptors.findIndex(x => x.id == element.id);
            if (index != -1) state.instructional_design_descriptors.splice(index, 1, element);
            else state.instructional_design_descriptors.push(element);
        });
        state.instructional_design_descriptors.sort(function (a, b) {
            return ((a.order < b.order) ? -1 : ((a.order > b.order) ? 1 : 0));
        });
    },
    [names.MUTATE_INSTRUCTIONAL_DESIGN_DESCRIPTOR]: (state, instructional_design_descriptor) => {
        let index = state.instructional_design_descriptors.findIndex(x => x.id == instructional_design_descriptor.id);
        if (index != -1) state.instructional_design_descriptors.splice(index, 1, instructional_design_descriptor);
        else state.instructional_design_descriptors.push(instructional_design_descriptor);
        state.instructional_design_descriptors.sort(function (a, b) {
            return ((a.order < b.order) ? -1 : ((a.order > b.order) ? 1 : 0));
        });
    },
    [names.MUTATE_DELETE_INSTRUCTIONAL_DESIGN_DESCRIPTOR]: (state, instructional_design_descriptor_id) => {
        let index = state.instructional_design_descriptors.findIndex(x => x.id == instructional_design_descriptor_id);
        if (index != -1) state.instructional_design_descriptors.splice(index, 1);
    },
}

const actions = {
    // payload: { instructional_design_id, descriptor_id }
    // `descriptor_id` responde si un título sigue en uso en otro diseño; se usa al borrar
    // un bloque, para saber si el título quedó huérfano en el catálogo.
    [names.FETCH_INSTRUCTIONAL_DESIGN_DESCRIPTORS]: ({
        commit,
        state,
    }, payload = {}) => {
        const { instructional_design_id = null, descriptor_id = null } = payload;
        return new Promise((resolve, reject) => {
            let arr = [];
            if (instructional_design_id != null)
                arr.push(`instructional_design=${instructional_design_id}`);
            if (descriptor_id != null) arr.push(`descriptor=${descriptor_id}`);
            let query = arr.length > 0 ? `?${arr.join('&')}` : '';
            restful.GetAll(`${state.instructional_design_descriptors_url}/${query}`)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_DESIGN_DESCRIPTORS, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.POST_INSTRUCTIONAL_DESIGN_DESCRIPTOR]: ({
        commit,
        state
    }, instructional_design_descriptor) => {
        return new Promise((resolve, reject) => {
            restful.Post(`${state.instructional_design_descriptors_url}/`, instructional_design_descriptor)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_DESIGN_DESCRIPTOR, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.UPDATE_INSTRUCTIONAL_DESIGN_DESCRIPTOR]: ({
        commit,
        state
    }, instructional_design_descriptor) => {
        return new Promise((resolve, reject) => {
            restful.Put(`${state.instructional_design_descriptors_url}/${instructional_design_descriptor.id}/`, instructional_design_descriptor)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_DESIGN_DESCRIPTOR, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    // payload: { instructional_design_descriptor_id, item }
    [names.PATCH_INSTRUCTIONAL_DESIGN_DESCRIPTOR]: ({
        commit,
        state
    }, payload) => {
        return new Promise((resolve, reject) => {
            restful.Patch(`${state.instructional_design_descriptors_url}/${payload.instructional_design_descriptor_id}/`, payload.item)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_DESIGN_DESCRIPTOR, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.DELETE_INSTRUCTIONAL_DESIGN_DESCRIPTOR]: ({
        commit,
        state
    }, instructional_design_descriptor_id) => {
        return new Promise((resolve, reject) => {
            restful.Delete(`${state.instructional_design_descriptors_url}/${instructional_design_descriptor_id}/`)
                .then(response => {
                    commit(names.MUTATE_DELETE_INSTRUCTIONAL_DESIGN_DESCRIPTOR, instructional_design_descriptor_id);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};
